import SEOHead from '../../components/SEOHead';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ShowcaseSection from './components/ShowcaseSection';
import UseCaseCarousel from './components/UseCaseCarousel';
import IndustrySolutions from './components/IndustrySolutions';
import WhySection from './components/WhySection';
import LeadCapture from './components/LeadCapture';
import Footer from './components/Footer';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://automate.tr';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Automate.TR",
    "description": "Enterprise AI automation and integration consultancy specializing in workflow automation, AI agents, and system integrations for Energy, Logistics, Legal, Manufacturing, and Finance industries.",
    "url": siteUrl,
    "logo": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/9c916c921dab6b7efa0ebb131a6ff24b/8c424d5b33adfc6c0fff567145be1c94.svg",
      "contentUrl": "https://static.readdy.ai/image/9c916c921dab6b7efa0ebb131a6ff24b/8c424d5b33adfc6c0fff567145be1c94.svg"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Sales",
      "availableLanguage": ["English", "Turkish"]
    },
    "areaServed": "Worldwide",
    "foundingLocation": {
      "@type": "Place",
      "addressCountry": "TR"
    },
    "serviceType": [
      "Workflow Automation",
      "AI Agent Development",
      "System Integration",
      "RPA Solutions",
      "Enterprise Automation"
    ],
    "knowsAbout": [
      "CrewAI",
      "LangGraph",
      "Enterprise workflow automation",
      "AI agents",
      "System integration",
      "Business process automation"
    ],
    "offers": {
      "@type": "AggregateOffer",
      "description": "Enterprise AI automation, workflow orchestration, and smart system integrations with real business impact."
    }
  };

  return (
    <>
      <SEOHead
        title="Automate.TR - AI Automation Integration Enterprise Workflow Solutions"
        description="Enterprise workflow automation, AI agents, and system integrations with n8n, CrewAI, and LangGraph. Transform your business processes with intelligent automation solutions for Energy, Logistics, Legal, Manufacturing, and Finance industries."
        keywords="workflow automation, AI agents, system integration, n8n automation, enterprise automation, RPA bots"
        canonical={`${siteUrl}/`}
        schema={schema}
      />
      <div className="bg-[#0a0a0f] text-white overflow-hidden">
        <HeroSection />
        <ServicesSection />
        <ShowcaseSection />
        <UseCaseCarousel />
        <IndustrySolutions />
        <WhySection />
        <LeadCapture />
        <Footer />
      </div>
    </>
  );
}
